/* section-le-social-proof.js — fill the marquee so the river never shows a gap */
if (!customElements.get('le-social-proof-marquee')) {
  customElements.define(
    'le-social-proof-marquee',
    class LeSocialProofMarquee extends HTMLElement {
      connectedCallback() {
        this.fill();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            this._filledFor = null;
            this.fill();
          });
        }
        if (typeof ResizeObserver !== 'undefined') {
          this._ro = new ResizeObserver(() => this.fill());
          this._ro.observe(this);
        }
      }

      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
      }

      fill() {
        const viewport = this.querySelector('.le-social-proof__viewport');
        const track = this.querySelector('.le-social-proof__track');
        const groups = this.querySelectorAll('.le-social-proof__group');
        if (!viewport || !track || groups.length < 2) return;

        const first = groups[0];
        const cycle = first.querySelector('.le-social-proof__cycle');
        if (!cycle) return;

        if (!this._unitHtml) this._unitHtml = cycle.outerHTML;

        const need = viewport.clientWidth;
        if (need < 8) return;
        if (this._filledFor === need) return;
        this._filledFor = need;

        first.innerHTML = this._unitHtml;
        const unitW = Math.max(first.scrollWidth, 1);

        let guard = 0;
        while (first.scrollWidth < need && guard < 24) {
          first.insertAdjacentHTML('beforeend', this._unitHtml);
          guard += 1;
        }
        // One extra cycle so the loop still covers ultrawide / subpixel rounding.
        first.insertAdjacentHTML('beforeend', this._unitHtml);

        for (let i = 1; i < groups.length; i += 1) {
          groups[i].innerHTML = first.innerHTML;
        }

        const speedSec =
          parseFloat(
            getComputedStyle(this.closest('.le-social-proof')).getPropertyValue(
              '--le-social-proof-speed'
            )
          ) || 80;
        // Keep the original calm pace: 3 phrase-cycles used to travel in `speed` seconds.
        const pxPerSec = (unitW * 3) / speedSec;
        track.style.animationDuration =
          first.scrollWidth / Math.max(pxPerSec, 4) + 's';
      }
    }
  );
}
